



































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,batchSettings,logoutPanel,selectClassPanel,addClassPanel,counter } from "@/components";
import { TbGoods, TbGoodsClass } from '@/http';
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
@Component({
    components: {
        padHeadPanel3,batchSettings,logoutPanel,selectClassPanel,addClassPanel,counter
    },
})
export default class addInventory extends Vue {
    public $refs: {
        barcode:HTMLFormElement;
    };

    pdList=[];

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    /**查询项 */
    searchValue = {
        name:"",
        goodsClassId:"",
        skip:0,
        count:10,
    }

    className = "";

    userInfo:any={};

    /**新增分类弹窗 */
    /**新增分类类型
     * true：一级分类
     * false：二级分类
     */
     isParent=true;

     addClassShow = false;
    /**一级分类信息 */
    firstInfo:any={};

    /**商品分类列表 */
    classList=[];
    checkClassId=[];
    checkClassName=[];

    isSaving = false;

    Loop=null;
    deleteIndex=null;

    maxlength = 6;

    isCheckedAll = false;
    isloadingAll = false;

    /**盘前库存总计 */
    get beforeInventoryTotal(){
        let val = 0;
        let arr = this.pdList.filter(v=>v.beforeInventory).map(v=>v.beforeInventory);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b));
        }
        return val;
    }
    /**盘后库存总计 */
    get actInventoryTotal(){
        let val = 0;
        let arr = this.pdList.filter(v=>v.actInventory).map(v=>v.actInventory);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b));
        }
        return val;
    }
    /**盈亏数总计 */
    get profitOrLossTotal(){
        let val = 0;
        let arr = this.pdList.filter(v=>v.profitOrLoss).map(v=>v.profitOrLoss);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b));
        }
        return val;
    }


    @Watch('searchValue.name')
    nameChange(val){
        this.getList();
    }
    @Watch('searchValue.goodsClassId')
    goodsClassIdChange(val){
        this.getList();
    }

    created() {
    }
    async mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        document.addEventListener('click',this.chargeInputFocus)

        // window["scanInput"] = async (val) => {
        //     await this.scanInput(val);
        // };
    }
    async scanInput(val){
        let res = await TbGoods.GetTbGoodsByBarCode({barCode:val});
        if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
            this.searchValue.name = res.barCode;
            let res2 = await TbGoods.GetGoodsItemsList({name:res.barCode,shopId:this.userInfo.shopId});
            if(res2.items.length>0){
                this.addPd(res2.items[0]);
            }
        }
    }
    isFocus = false
    getFocus(){
        this.isFocus = true
    }
    inputBlur(){
        this.isFocus = false
        document.addEventListener('click',this.chargeInputFocus)

    }
    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {
            this.$nextTick(()=>{
                this.$refs['barcode'].select()
                document.addEventListener('keydown', this.handleScanCode)
            })
        }
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        console.log('14',event.target.value)
        if(this.isFocus){
            this.searchValue.name = event.target.value
        }else{
            if (event.key === 'Enter' || event.keyCode == 13) {
                console.log('查询1234',this.scanCodes,event.target.value)
                let code = this.scanCodes?this.scanCodes:event.target.value
                this.scanInput(code)
                this.scanCodes = ''
            return
            }
        }

    }

    /**批量设置 */
    batchSet(val){
       if(this.pdList.length>0){
        this.pdList = this.pdList.map(v=>{
            return{
                ...v,
                actInventory:val,
                profitOrLoss:calculate.subtraction(val,v.beforeInventory)
            }
        })
       }
    }

    /**清空 */
    clearAll(){
        if(this.pdList.length==0) return;

        this.tipTitle = "操作提醒";
        this.tipText = `确定清空库存盘点列表吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 1;
        this.tipShow = true;
    }

    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            /**清空 */
            case 1:
                this.pdList = [];
                break;
            /**未添加盘点商品 */
            case 2:
                break;
            /**删除商品 */
            case 3:
                this.pdList.splice(this.deleteIndex,1);
                break;

            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }

            let s = this.searchValue.count;
            let res = await TbGoods.GetGoodsItemsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId
            }))
            this.list = this.searchValue.skip==0? res.items.map(v=>{
                return{
                    ...v,
                    costPrice:v.costPrice.toFixed(2),

                }
            }):this.list.concat(res.items.map(v=>{
                return{
                    ...v,
                    costPrice:v.costPrice.toFixed(2),
                }
            }));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            console.log('list',this.list);

            }
    }
    clearClass(){
        this.className="";
        this.searchValue.goodsClassId = "";
        this.getClassList();
    }
    /**获取商品列表 */
    async getList(){
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=10;
        this.total = 0;
        this.currentPage = 1;

        // this.onRefresh();
        let res = await TbGoods.GetGoodsItemsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId
            }))
            this.list =res.items.map(v=>{
                return{
                    ...v,
                    costPrice:v.costPrice.toFixed(2),

                }
            })
            this.total  = res.totalCount;
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            name:"",
            goodsClassId:"",
            skip:0,
            count:10,
        }
        this.getList();
    }

    addClass(type){
        this.isParent = type;
        this.addClassShow=true;
        if(!type){
            this.$refs['addClassPanel'].init(this.firstInfo);
        }
    }
    addSecondClass(item){
        this.firstInfo = item;
        this.addClass(false);
    }

    closeFun(){
        this.addClassShow = false;
    }
    async confirmSave(res){
        let id = this.isParent?res.id:this.firstInfo.id+','+res.id;
        this.searchValue.goodsClassId = id;
        await this.getList();
        this.$refs['selectClassPanel'].closeFun();
    }

    /**递归搜索结果 */
    async mapClassId(data) {
        data.map((v) => {
            if (v.items && v.items.length > 0) {
                this.mapClassId(v.items);
            }
            if ( this.searchValue.goodsClassId.indexOf(",")==-1) {
                if(this.searchValue.goodsClassId==v.id){
                    this.checkClassId.push(v.id);
                    this.checkClassName.push(v.name);
                }
            }else{
                let arr = this.searchValue.goodsClassId.split(",")
                    if(arr.some(k=>k==v.id)){
                        this.checkClassId.unshift(v.id);
                        this.checkClassName.unshift(v.name);
                    }

            }
        });

    }
    async getClassList(){
        let res = await TbGoodsClass.GetAllGoodsClassList({
            needGoodsCount:false
        })
        this.classList = res;
    }
    /**匹配分类名 */
    async getClassName(){
        this.checkClassId=[];
        this.checkClassName=[];
        await this.getClassList();
        await this.mapClassId(this.classList);
        if((this.searchValue.goodsClassId.indexOf(",") == -1&&this.checkClassId.length>0)||(this.searchValue.goodsClassId.indexOf(",")>-1&&this.checkClassId.length==2)){
            this.className= this.checkClassName.join('-');

            }else{
            this.searchValue.goodsClassId = this.classList.some(v=>v.name=='其他分类')?this.classList.find(v=>v.name=='其他分类').id:'';
            this.className="其他分类";

    }
    };

    chooseClass(item){
        this.searchValue.goodsClassId = item.id;
        this.className = item.name;
    }

    addPd(item){
        let index = this.pdList.findIndex(v=>v.id==item.id);
        if(index>-1){
            let newObj = this.pdList[index];
            console.log('newObj',newObj)
            this.pdList.splice(index,1);
            this.pdList.unshift(Object.assign({},newObj,{
                actInventory:Number(newObj.actInventory)+1,
                profitOrLoss:newObj.profitOrLoss+1
            }))
        }else{
            if(this.pdList.length>=500){
                    Toast("最多盘点500条数据")
					return;
				}
            let obj = Object.assign({},item,{
                beforeInventory:item.stock,
                actInventory:item.stock>0?item.stock:0,
                profitOrLoss:item.stock>0?0:Math.abs(item.stock),
            })
            this.pdList.unshift(obj);
        }
        this.$forceUpdate();
    }

    /**计数器 */
    finishStep(val,index){
        this.$set(this.pdList[index],'actInventory',val);
        let profitOrLoss = calculate.subtraction(val,this.pdList[index].beforeInventory)
        this.$set(this.pdList[index],'profitOrLoss',profitOrLoss);
    }

    async saveFun(){
        if(this.isSaving) return;
        if(this.pdList.length==0){
            this.tipTitle = "操作提醒";
            this.tipText = `请先添加盘点商品！`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 2;
            this.tipShow = true;
            return;
        }
        this.isSaving = true;
            Toast.loading({
                message: "盘点中",
                duration: 0, // toast不消失
            });
        try {
            let res = await TbGoods.PostUpdateInventoryCount({
                list:this.formateArr()
            })
            Toast("保存成功");
            this.pdList = [];
            this.onRefresh();
            this.isSaving = false;
            Toast.clear();
        } catch (error) {
            this.isSaving = false;
            Toast.clear();
        }

    }

    formateArr(){
        let arr =[];
        if(this.pdList.length>0){
            arr = this.pdList.map(v=>{
                return {
                    id:v.id,
                    goodsId:v.goodsId,
                    goodsName:v.goodName,
                    costPrice:Number(v.costPrice),
                    beforeInventory:v.beforeInventory,
                    actInventory:v.actInventory,
                    profitOrLoss:v.profitOrLoss,
                    creatorId:this.userInfo.id,
                    creatorName:this.userInfo.name,
                }
            })
        }
        return arr;
    }

    delItems(index){
        this.Loop = setTimeout(function() {
            this.tipTitle = "操作提醒";
            this.tipText = `确认移除该商品吗？`;
            this.btnNums=2;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.deleteIndex = index;
            this.tipType = 3;
            this.tipShow = true;
        }.bind(this), 200);//手指或者鼠标按下等待的时间
    }

    showClass(){
        this.$refs['selectClassPanel'].showFun(this.searchValue.goodsClassId);
    }

    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    checkAllFun(event){
        this.isCheckedAll = event.detail;
    }
    async pdAllFun(){
        if(this.isloadingAll) return;
        if(this.isCheckedAll){
            this.isloadingAll = true;
            Toast.loading({
                message: "加载中",
                duration: 0, // toast不消失
            })
            try {
                let res = await TbGoods.GetGoodsItemsList(Object.assign({},this.searchValue,{
                    shopId:this.userInfo.shopId,
                    skip:0,
                    count:500
                }))
                let list = res.items.map(v=>{
                    let index = this.pdList.findIndex(vv=>v.id==vv.id);
                    let newObj = this.pdList[index];
                    return {
                        ...v,
                        costPrice:v.costPrice.toFixed(2),
                        beforeInventory:v.stock,
                        actInventory:index>-1?Number(newObj.actInventory)+1:v.stock>0?v.stock:0,
                        profitOrLoss:index>-1?Number(newObj.profitOrLoss)+1:v.stock>0?0:Math.abs(v.stock)
                    }
                });
                this.pdList = list;
                this.isloadingAll = false;
                Toast.clear();
            } catch (error) {
                this.isloadingAll = false;
                Toast.clear();
                //TODO handle the exception
            }

        }
    }


}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/addInventory.vue